// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assign-reject[data-v-6736f124] {\n  display: block;\n  width: 100%;\n  padding: 20px 30px;\n}\n.assign-reject__text[data-v-6736f124] {\n  padding-bottom: 20px;\n  font-size: 14px;\n}\n.assign-reject__btn[data-v-6736f124] {\n  display: inline-block;\n  width: auto;\n  margin-right: 30px;\n  padding: 0 30px;\n}\n", ""]);
// Exports
module.exports = exports;
